import Navigation from "../../components/Navigation";
import { Link } from "react-router-dom";
// We need icons for a richer card design
import { Briefcase, FileText, TrendingUp } from "lucide-react"; 
import { Helmet } from "react-helmet-async";
import "./style.css";

const services = [
	{ 
        title: "Private Contracts", 
        desc: [
            "Drafting, reviewing, and advising on agreements between private parties to ensure that the terms are clear, legally valid, and enforceable under applicable law.",
        ],
        icon: FileText,
        // slug: "/services/private-contracts"
    },
	// { 
    //     title: "Conveyancing", 
    //     desc: "In law, conveyancing is the transfer of legal title of real property from one person to another, or the granting of an encumbrance such as a mortgage or a lien.",
    //     icon: Gavel,
    //     slug: "/services/conveyancing"
    // },
	{ 
        title: "Secretarial Services", 
        desc: [
            "Providing administrative and corporate support, including company registration, document filing, record keeping, and compliance with statutory and regulatory requirements.",
        ],
        icon: Briefcase,
        // slug: "/services/business-solutions"
    },
	{ 
        title: "Bookkeeping", 
        desc: [
            "The systematic recording, organising, and maintaining of a business’s financial transactions to ensure accurate financial records and proper financial management.",
        ],
        icon: TrendingUp,
        // slug: "/services/financial-planning"
    },
    {
        title: "Deceased Estates",
        desc: [
            "Administration and submission of tax matters relating to a deceased person’s estate, including final tax returns and ongoing tax obligations, in accordance with the requirements of the South African Revenue Service (SARS).",
        ],
        icon: FileText,
        // slug: "/services/wills-and-deceased-estates"
    },
    {
        title: "Tax Compliance & SARS Assistance",
        desc: [
            "The systematic recording, organising, and maintaining of a business’s financial transactions to ensure accurate financial records and proper financial management. (bookkeeping)",
        ],
        icon: TrendingUp,
        // slug: "/services/tax-compliance-and-sars-assistance"
    },
    {
        title: "Legal Advisory",
        desc: [
            "Provision of professional legal guidance to individuals and businesses",
        ],
        icon: TrendingUp,
        // slug: "/services/law-of-contract"
    },
    // {
    //     title: "Family Law",
    //     desc: [
    //         "Placeholder",
    //     ],
    //     icon: TrendingUp,
    //     // slug: "/services/family-law"
    // }
];

const Services = () => {
	return (
		<div className="services-page-wrapper">
			<Navigation />
			<Helmet>
				<title>Jean Tax & Legal Practitioners | Areas of Practice</title>
				<meta name="description" content="Detailed areas of practice: private contracts, secretarial services, bookkeeping, deceased estates, tax compliance and legal advisory." />
				<meta name="keywords" content="private contracts, bookkeeping, deceased estates, SARS, compliance, legal advisory" />
				<link rel="canonical" href="https://jeantaxandlegal.co.za/areas-of-practice" />
				<meta property="og:title" content="Jean Tax & Legal Practitioners | Areas of Practice" />
				<meta property="og:description" content="Comprehensive practice areas to support your tax and legal needs." />
				<meta property="og:type" content="website" />
				<meta property="og:url" content="https://jeantaxandlegal.co.za/areas-of-practice" />
			</Helmet>
			<main className="services-main">
				
				{/* Hero Section */}
				<section className="services-hero">
                    <div className="container">
                        <div className="hero-content">
                            <h1>Our Areas of Practice</h1>
                            <div className="hero-underline"></div>
                            <p>Explore the diverse range of legal and tax services we offer to meet your specific needs.</p>
                        </div>
                    </div>
				</section>

				{/* Services List Grid */}
				<section className="services-list">
                    <div className="container">
                        <div className="services-cards-grid">
                            {services.map((s, i) => (
                                <Link to={s.slug} className="service-card-link" key={i}>
                                    <div className="card service-card">
                                        <div className="card-icon">
                                            {/* Render the Lucide icon component */}
                                            {s.icon && <s.icon size={36} />} 
                                        </div>
                                        <h3 className="card-title">{s.title}</h3>
                                        <ul className="card-description">
                                            {s.desc.map((point, index) => (
                                                <li key={index}>{point}</li>
                                            ))}
                                        </ul>
                                        <div className="read-more">
                                            {/* Learn More <ArrowRight size={16} /> */}
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                <br />
				</section>

                {/* Optional Call to Action (Reusing newsletter style) */}
                <section className="cta-contact">
                    <div className="container">
                        <h2>Ready to Start?</h2>
                        <div className="hero-underline"></div>
                        <p>Book a consultation to discuss your specific tax or legal requirements.</p>
                        <Link to="/contact" className="btn-cta">
                            Book Consultation Now
                        </Link>
                    </div>
                </section>
			</main>
			{/* <Footer /> */}
		</div>
	);
};

export default Services;